/*eslint-disable*/
import React from 'react';

// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from 'reactstrap';

const Login = () => {
  return (
    <>
      <footer className="py-5" style={{ backgroundColor: 'transparent' }}>
        <Container>
          <Row className="align-items-center justify-content-xl-center">
            <Col xl="8">
              <Nav className="nav-footer justify-content-center justify-content-xl-center">
                <NavItem>
                  <NavLink href="https://joulepoint.com" target="_blank">
                    © {new Date().getFullYear()} Joulepoint Pvt. Ltd
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="https://s3.ap-south-1.amazonaws.com/cdn.joulepoint.com/Joulepoint-+Privacy+Policy-web+application.pdf"
                    target="_blank"
                  >
                    Privacy Policy
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="https://s3.ap-south-1.amazonaws.com/cdn.joulepoint.com/Joulepoint+-+Refund+and+Cancellation+Policy.pdf"
                    target="_blank"
                  >
                    Refund and Cancellation Policy
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    href="https://s3.ap-south-1.amazonaws.com/cdn.joulepoint.com/Joulepoint-+Terms+and+conditions.pdf"
                    target="_blank"
                  >
                    Terms and Conditions
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
          </Row>
        </Container>
      </footer>
    </>
  );
};

export default Login;
